export const BUYER_PROFILE_UPDATED = `buyerProfiles/BUYER_PROFILE_UPDATED`
export const BUYER_PROFILE_CREATE = `buyerProfiles/BUYER_PROFILE_CREATE`
export const BUYER_PROFILE_ADD = `buyerProfiles/BUYER_PROFILE_ADD`
